import React from "react";
import Image from "next/image";

type CardProps = {
  icon: string;
  title?: string;
  description?: string;
}[];

const FeaturesCard = ({ details }: { details: CardProps }) => {
  return (
    <div className="bg-surface-white outline-[0.5px] outline-surface-light/88 drop-shadow-[0_0_24px_rgba(226,226,226,0.8)] flex flex-col md:flex-row md:items-center md:justify-center rounded-[20px] px-4 py-5 md:px-2 md:py-3.5 lg:py-4.5 xl:py-6 gap-y-3.5  md:gap-y-0 md:gap-x-9 lg:gap-x-10 xl:gap-x-20 text-sm sm:text-xs lg:text-sm xl:text-base text-surface md:text-center lg:text-start">
      {details.map((detail, index) => (
        <div
          key={detail.description}
          className="flex flex-col md:flex-row sm:items-center gap-y-4 md:gap-x-6.5 xl:gap-x-8 "
        >
          <div
            className={`flex flex-row md:flex-col lg:flex-row  gap-x-3 md:gap-y-3 lg:gap-x-3 ${detail.title ? "items-start md:items-center lg:items-start" : "text-left md:text-center items-center"}`}
          >
            <div className="relative shrink-0 size-9 md:size-8 xl:size-10">
              <Image
                src={`${detail.icon}`}
                alt={detail.title || "Feature Icon"}
                fill
                className="size-full object-contain object-center"
              />
            </div>

            <div className="space-y-1">
              <p className="font-semibold leading-5 md:leading-3.5 lg:leading-5 xl:leading-6">
                {detail.title}
              </p>
              <p className="">{detail.description}</p>
            </div>
          </div>

          <span
            className={`w-full h-[0.5px] md:h-15 lg:h-9 xl:h-11 md:w-[0.5px] md:border-r-[0.5px] bg-surface/50 ${index === details.length - 1 ? "hidden" : ""}`}
          />
        </div>

        //
      ))}
    </div>
  );
};

export default FeaturesCard;
